<template>
    <div>
        <box-motivo :data="data" />
    </div>
</template>

<script>
// Components.
import BoxMotivo from './components/Index'

export default {
    components: { BoxMotivo },
    props: {
        data: { type: Object, required: true },
    }
}
</script>
